import React from 'react';
import Icons from '../../../Containers/Icons';

let VisConf = (props) => {
  let vis = props.vis;
  return (
    <li key={vis.id} className={`vis ${vis.active}`}>
      <div className="visualesLi">
        <span className="visual">{vis.abr}</span>
        <span className="arrow gray"><Icons name="arrowThin"/></span>
        <span>{vis.name}</span>
      </div>
      <span className="trash" onClick={() => props.selectVis(props.index)}><Icons name="trash"/></span>
    </li>
  )
}
export default VisConf;


// WEBPACK FOOTER //
// ./src/Components/Admin/Point/VisConf.js